<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* margin: 20px 0; */
  width: 100%;
}

body{
    color: #555;
    margin-left: auto;
    margin-right: auto;
    line-height: 25px;
}

@media screen and (max-width: 3600px) {
    body {
        width: 650px;
    }
}

@media screen and (max-width: 500px) {
    body {
        width: 100%;
        left: 0;
        right: 0;
    }
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue